module.exports = __webpack_public_path__ + "img/MEDIA010.6c9c4897.jpg";